<template>
    <div>
        <span v-html="$tm('contestantimport.newimporttext', '', true)"></span>
        <div class="p-3">
            <InputText
                v-model="value.name"
                :placeholder="$tm('general.name')"
            />
        </div>
        <AlertMessage
            v-if="formatExists"
            type="warning"
        >
            {{ $tm('contestantimport.formatexists') }}
        </AlertMessage>
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import InputText from '../Basic/InputText.vue';
import type { SelectLine } from '@/objects';
import { watchDebounced } from '@vueuse/core';
import AlertMessage from '../Alert/AlertMessage.vue';

const props = defineProps<{
    modelValue: { name: string };

    formatList: SelectLine[];
}>();

const emit = defineEmits(['update:modelValue']);

const value = computed({
    get: () => props.modelValue,
    set: (value) => emit('update:modelValue', value),
});

const formatExists = ref(false);

watchDebounced(
    value,
    (nv) => {
        formatExists.value = props.formatList.some((f) => f.value?.toString().toLocaleLowerCase() === nv.name.toLocaleLowerCase());
    },
    { deep: true, debounce: 500 },
);
</script>
